module.exports = __webpack_public_path__ + "static/media/Seguridad.8470b824.svg";